import { ApiSavedPortfolio } from 'api/rtk-api'

import { PORTFOLIO_TYPE } from '@/constants'

import { unpascal } from '../../../../modules/tradebuilder-v2/util'
import { DateDisplay, Numeric, Percent, Section, Space } from '../../atoms'
import { Attribute } from '../../molecules/attribute'

export type PortfolioDetailsProps = {
  calculatedMultiplier: number
  portfolio: ApiSavedPortfolio | null
}

export function PortfolioDetails({ calculatedMultiplier, portfolio }: PortfolioDetailsProps) {
  return (
    <Section type="primary">
      <Space isflex flexDirection="column">
        <Attribute name="Name">{portfolio.portfolioName}</Attribute>
        <Attribute name="Portfolio ID">{portfolio.portfolioId}</Attribute>
        <Attribute name="Type">{PORTFOLIO_TYPE[portfolio.type].value}</Attribute>
        <Attribute name="Rebalancing type">{portfolio.rebalancingDefinition?.type}</Attribute>
        {portfolio?.rebalancingDefinition?.type === 'Frequency' && (
          <Attribute name="Rebalancing frequency">
            {unpascal(portfolio?.rebalancingDefinition?.frequency)}
          </Attribute>
        )}

        {portfolio.rebalancingDefinition?.type === 'Weight' && (
          <Attribute name="Rebalancing tolerance">
            <Percent
              fixed
              numDecimalPlaces={2}
              value={(portfolio.rebalancingDefinition?.weightsTolerance || 0) * 100}
            />
          </Attribute>
        )}
        <Attribute name="Portfolio defined multiplier">
          <Numeric value={portfolio.multiplier} />
        </Attribute>
        <Attribute name="Continuous protection multiplier">
          <Numeric value={calculatedMultiplier} />
        </Attribute>
        <Attribute name="Term protection multiplier">
          <Numeric value={calculatedMultiplier} />
        </Attribute>
        <Attribute name="Tax classification">{portfolio.taxClassification}</Attribute>
        {portfolio.type === PORTFOLIO_TYPE.FundOfFunds.key && (
          <Attribute name="Start date">
            {'startDate' in portfolio && <DateDisplay value={portfolio?.startDate as string} />}
          </Attribute>
        )}
      </Space>
    </Section>
  )
}
